import React, { useState, useEffect, ChangeEventHandler, FocusEventHandler } from "react";
import { IPersonalData, LegalRequestStatusChecking, LegalRequestStatusCheckingDescription } from "./types";
import { LegalRequestStatusCheckingColor } from "./types"
import { DocumentType, documentTranslations } from "./types";
import DocumentsTable from "../Tables/DocumentsTable";
import Popup from "../Popups/Popup";

import EditPersonalData from "../Profile/Details/EditPersonalData";
import Loading from "../Ui/Loading";

import useGetLegalRequestDocuments from "../Api/useGetLegalRequestDocuments";
import useGetPersonalAccountInfo from "../Api/useGetPersonalAccountInfo";
import usePostUpdatePersonalAccountInfo from "../Api/usePostUpdatePersonalAccountInfo";
import usePostAddPersonalDataDocument from "../Api/usePostAddPersonalDataDocument";
import usePostRemoveDocumentFromLegalRequest from "../Api/usePostRemoveDocumentFromLegalRequest";
import usePostSendLegalRequest from "../Api/usePostSendLegalRequest";
import usePostCreateDraftLegalRequest from "../Api/usePostCreateDraftLegalRequest";
import EditUploadedDocumentPopup from "../Popups/EditUploadedDocument";
import usePostAddSignatureForLegalRequest from "../Api/usePostAddSignatureForLegalRequest";
import { CheckingStatuses } from "../enums/DocCheckingStatuses";

enum CompanyTypes {
    OOO = 1,
    IP = 2,
    Fiz = 3
}

export var CompanyTypesName: { [key: CompanyTypes]: string; } = {};
CompanyTypesName[CompanyTypes.OOO] = 'Юридическое лицо';
CompanyTypesName[CompanyTypes.IP] = 'Индивидуальный предприниматель';
CompanyTypesName[CompanyTypes.Fiz] = 'Физическое лицо';

interface IPropsType {

}

function PersonalDataTable() {
    const [popupHead, setPopupHead] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadTypes, setUploadTypes] = useState(null);

    const {
        data: docs,
        error: documentsError,
        isError: documentsIsError,
        isFetching: documentsLoading,
        refetch: getDocuments
    } = useGetLegalRequestDocuments();
    const {
        data: personalData,
        error: personalDataError,
        isError: personalDataIsError,
        isFetching: personalDataLoading,
        refetch: getPersonalData
    } = useGetPersonalAccountInfo();
    const {
        mutate: updatePersonal,
        data: updatePersonalResult,
        isPending: updatePersonalLoading,
        isError: updatePersonalIsError,
        isSuccess: updatePersonalSuccess,
        error: updatePersonalError
    } = usePostUpdatePersonalAccountInfo();
    const {
        mutate: sendLegalRequest,
        data: sendLegalRequestResult,
        isPending: sendLegalRequestLoding,
        isError: sendLegalRequestIsError,
        isSuccess: sendLegalRequestSuccess,
        error: sendLegalRequestError
    } = usePostSendLegalRequest();
    const {
        mutate: createDraftLegalRequest,
        data: createDraftLegalRequestResult,
        isPending: createDraftLegalRequestLoading,
        isError: createDraftLegalRequestIsError,
        isSuccess: createDraftLegalRequestSuccess,
        error: createDraftLegalRequestError
    } = usePostCreateDraftLegalRequest();

    const [documents, setDocuments] = useState(docs);

    useEffect(() => {
        if (docs) setDocuments(docs);
    }, [docs])
    useEffect(() => {
        if (documents) setUploadTypes(documents.map(doc => doc.DocumentTypeId));
    }, [documents])

    useEffect(() => {
        setLoading(documentsLoading || personalDataLoading || updatePersonalLoading || sendLegalRequestLoding || createDraftLegalRequestLoading);
    }, [documentsLoading, personalDataLoading, updatePersonalLoading, sendLegalRequestLoding, createDraftLegalRequestLoading])

    useEffect(() => {
        if (sendLegalRequestSuccess) getPersonalData();
        if (createDraftLegalRequestSuccess) getPersonalData();
    }, [sendLegalRequestSuccess, createDraftLegalRequestSuccess]);

    useEffect(() => {
        if (documentsIsError || personalDataIsError || updatePersonalIsError || sendLegalRequestIsError) {
            setIsOpen(true);
            setPopupHead({ title: "Внимание", description: documentsError || personalDataError || updatePersonalError || sendLegalRequestError })
        }
    }, [documentsIsError, personalDataIsError, updatePersonalIsError, sendLegalRequestIsError, createDraftLegalRequestIsError])

    const onConfirmLegal = async () => {
        try {
            const res = await getDocuments();
            if (res.data.some(doc => !doc.IsSignatureVendor)) {
                setIsOpen(true);
                setPopupHead({ title: "Внимание", description: "Подпишите загруженные документы" })
                return;
            }
        } catch (err) {
            console.log(err);
        }

        if (personalData?.RequiredDocumentsType.every(el => uploadTypes.includes(el))) {
            sendLegalRequest(personalData.CompanyId);
        } else {
            const missingDocuments = personalData?.RequiredDocumentsType.filter(i => !uploadTypes.includes(i));
            setIsOpen(true);
            setPopupHead({ title: "Внимание", description: `Загрузите документы: ${missingDocuments.map(i => documentTranslations[i])}` })
            return;
        }
    }

    const { mutate: addDoc, data: addDocumentResult, isPending: addDocumentLoading, isError: addDocumentIsError, isSuccess: addDocumentSuccess, error: addDocumentError } = usePostAddPersonalDataDocument();

    const handleDocument = (data) => {
        addDoc(data);
    }

    return (
        <div className="personalDataTable" style={{ position: "relative", width: "100%" }}>
            {loading && (<Loading />)}

            <EditPersonalData
                data={personalData}
                save={updatePersonal}
                StatusChecking={personalData?.StatusChecking}
                saveLegalRequest={onConfirmLegal}
                Mode={personalData?.Mode}
                draftRequest={createDraftLegalRequest}
            />

            <div className="documentsDataTable" style={{marginTop: "20px"}}>
                {[CheckingStatuses.NoStatus, CheckingStatuses.Draft, CheckingStatuses.CheckFailed].includes(personalData?.StatusChecking) &&
                    <EditUploadedDocumentPopup
                        handleDocument={handleDocument}
                        updateDocuments={() => { getDocuments() }}
                        CanUploadFromAllDocs={true}
                        MaxSizeFile={personalData?.MaxSizeFile}
                        AllowFileTypes={personalData?.AllowFileTypes}
                        RequiredTypes={personalData?.RequiredDocumentsType}

                        isLoading={addDocumentLoading}
                        isError={addDocumentIsError}
                        isSuccess={addDocumentSuccess}
                        error={addDocumentError}
                    />   
                }
                <DocumentsTable
                    data={documents || []}
                    getDocuments={getDocuments}
                    removeDocument={usePostRemoveDocumentFromLegalRequest}
                    onRemove={(docId) => setDocuments(prev => prev.filter(doc => doc.Id !== docId))}
                    Mode={personalData?.Mode}
                    addSignature={usePostAddSignatureForLegalRequest}
                />
            </div>

            <div className="statusChecking">
                <h4 className="purpleTextHead">Статус:</h4>
                <p className="defaultDescription">{LegalRequestStatusCheckingDescription[personalData?.StatusChecking]}</p>
            </div>

            {personalData?.DeclineReason && (
                <div style={{ marginTop: "10px" }}>
                    <button className="defaultPinkButton"
                        onClick={() => {
                            setIsOpen(true);
                            setPopupHead({ title: "Причина отказа", description: personalData?.DeclineReason || "Причина не найдена" })
                        }}
                    >
                        Причина предыдущего отказа
                    </button>
                </div>
            )}
            <h4 className="purpleTextHead">История заявок на подтверждение юридический действий:</h4>
            <table className="defaultTable">
                <thead>
                    <tr>
                        <th>Дата</th>
                        <th>Статус</th>
                        <th>Причина отказа</th>
                    </tr>
                </thead>
                <tbody>
                    {personalData?.LegalRequests?.length > 0 ? (
                        personalData.LegalRequests.map(legalRequest =>
                            <tr>
                                <td>{new Date(legalRequest.DateApproved).toLocaleDateString('ru-RU')}</td>
                                <td style={{ color: LegalRequestStatusCheckingColor?.[legalRequest.StatusId] ?? 'black' }}>
                                    {LegalRequestStatusCheckingDescription?.[legalRequest.StatusId] ?? 'Неизвестный статус'}
                                </td>
                                <td>{legalRequest.DeclineReason}</td>
                            </tr>) 
                    )
                        :
                        (<tr><td>Здесь пусто</td></tr>)
                    }

                </tbody>
            </table>


            <Popup
                isOpen={isOpen}
                close={() => setIsOpen(false)}
                head={popupHead}
            />
        </div>
    );

}

export default React.memo(PersonalDataTable);